import React from 'react'

import { useManageConnectedDrawerState } from 'packages/common/src/modals/Drawer/hooks/useManageConnectedDrawerState'

import { setOnCallTaskDrawerState } from 'app/fieldapp/store/ui/actions'
import { getOnCallTaskDrawerState } from 'app/fieldapp/store/ui/selectors'

import { CoverageEntry, CoverageEntryProps } from './CoverageEntry'

export type CoverageEntryContainerProps = Pick<CoverageEntryProps, 'entry'>

export const CoverageEntryContainer: React.FC<CoverageEntryContainerProps> = ({
  entry,
}) => {
  const onCallTaskDrawerManager = useManageConnectedDrawerState({
    dispatchableToggleDrawerAction: setOnCallTaskDrawerState,
    selector: getOnCallTaskDrawerState,
  })

  return <CoverageEntry drawerManager={onCallTaskDrawerManager} entry={entry} />
}
